// src/app/modules/Visitors/index.jsx
import React, { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { VisitorsPage } from "./main"; // Updated import name
import { LayoutSplashScreen } from "../../../../_metronic/layout";

export function Visitors() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Routes>
        {/* Use /* wildcard to allow nested routes */}
        <Route path="/*" element={<VisitorsPage />} />
      </Routes>
    </Suspense>
  );
}